module.exports = __webpack_public_path__ + "img/pt_Ecran 6.29f8362d.jpg";